module.exports = __webpack_public_path__ + "static/heroBg2-32f9a26a0c3a60be0413be39512fe27b.jpg";